import {
  ClusterLayer,
  DatumLayer,
  HeatmapLayer,
  LayerCollection,
  VectorLayer,
} from '@datum-map';
import { UserActivityFeature } from '@datum-map/types';
import { MouseController } from './MouseController';
import { CardData } from '../LinkController/types';
import { Card } from '../LinkController/Card';

export class TableCardMouseControllerLink {
  constructor(
    private _mouseController: MouseController,
    private _card: Card,
    private _collection: LayerCollection,
  ) {}

  bind = () => {
    this._mouseController.on('left_click', this._handler);

    return this.unbind;
  };

  unbind = () => {
    this._mouseController.un('left_click', this._handler);
  };

  private _handler = (targetData: UserActivityFeature) => {
    const cardData = this._getTableRecordCardData(targetData);

    if (!!cardData) {
      this._card.setCard(cardData);

      return;
    }
  };

  private _getTableRecordCardData(
    feature: UserActivityFeature,
  ): CardData | undefined {
    const layerName = feature[0];
    const record = feature[1];
    const { id } = record;

    if (!id || !layerName) return;

    const layer = this._collection.getLayer(layerName);

    if (!layer || !this._isVectorLayer(layer)) return;

    const tableName = layer.apiLayer.data_source;

    if (!tableName) return;

    return {
      tableName,
      recordId: '' + id,
      layerName,
    };
  }

  private _isVectorLayer(
    layer: DatumLayer,
  ): layer is VectorLayer | HeatmapLayer | ClusterLayer {
    return (
      layer instanceof VectorLayer ||
      layer instanceof HeatmapLayer ||
      layer instanceof ClusterLayer
    );
  }
}
